import { ORDERS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const ordersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getOrders: build.query({
      query: (params = {}) => ({ url: ORDERS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Order', result),
    }),
    getOrderById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return {
          url: ORDERS.BY_ID(id),
          method: 'GET',
          params,
        };
      },
      providesTags: (_r, _e, arg) => [
        { type: 'Order', id: typeof arg === 'object' && arg != null ? arg.id : arg },
      ],
    }),
    createOrder: build.mutation({
      query: (body) => ({ url: ORDERS.CREATE, method: 'POST', data: body }),
      invalidatesTags: [{ type: 'Order', id: 'LIST' }],
    }),
    updateOrder: build.mutation({
      query: ({ id, ...body }) => ({
        url: ORDERS.BY_ID(id),
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Order', id },
        { type: 'Order', id: 'LIST' },
      ],
    }),
    deleteOrder: build.mutation({
      query: (id) => ({ url: ORDERS.DELETE(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Order', id },
        { type: 'Order', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useLazyGetOrdersQuery,
  useGetOrderByIdQuery,
  useLazyGetOrderByIdQuery,
  useCreateOrderMutation,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
} = ordersApi;
